import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";
import type SignalTypeWithIcon from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalTypeWithIcon";

import { SignalsListTypeItem } from "./SignalsListTypeItem";
import { StyledSignalsListTypesWrapper } from "./styles";

interface ISignalsListTypesProps {
    className?: string;
    signalTypes: readonly SignalTypeWithIcon[];
    signalsCountPerType?: Readonly<Record<SignalType, number>>;
    onSignalTypeClick?: (signalType: SignalType) => void;
    dataAutomation?: string;
}

export const SignalsListTypes = ({
    className,
    signalTypes,
    signalsCountPerType,
    onSignalTypeClick,
    dataAutomation = "signals-list-per-type",
}: ISignalsListTypesProps) => {
    return (
        <StyledSignalsListTypesWrapper
            className={className}
            data-automation={dataAutomation}
        >
            {signalTypes.map((signal) => (
                <SignalsListTypeItem
                    key={signal.type}
                    title={signal.type}
                    icon={signal.icon}
                    count={signalsCountPerType?.[signal.type] ?? 0}
                    onClick={onSignalTypeClick ? () => onSignalTypeClick(signal.type) : undefined}
                />
            ))}
        </StyledSignalsListTypesWrapper>
    );
};
